<div class="content p-24">

    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">{{'Vat rate data'|translate}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Vat name'|translate}}</mat-label>
                    <input matInput formControlName="vatName" required>
                    <mat-error>{{'Vat name is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Vat value'|translate}}</mat-label>
                    <input matInput formControlName="vatValue" required>
                    <mat-error>{{'Vat value is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Country'|translate}}</mat-label>
                    <mat-select formControlName="country" required>
                        <mat-option [value]="country.id" *ngFor="let country of countries">
                            {{country.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>{{'Country is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent">
                        {{'Save'|translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>